import { render, staticRenderFns } from "./MobileCommunityQna.vue?vue&type=template&id=0ee7663a&scoped=true&"
import script from "./MobileCommunityQna.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityQna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee7663a",
  null
  
)

export default component.exports